// extracted by mini-css-extract-plugin
module.exports = {"captionIcon":"caption_captionIcon__bDhS4","caption":"caption_caption__0Vcj4","captionText":"caption_captionText__wAndU"};